<script>

    import SelectorWidget from './SelectorWidget';

    export default SelectorWidget.extend({
        //
    });

</script>
